<template>
    <v-card v-if="student" tile flat height="35">
        <v-row class="px-3" align="center">
            <v-col cols="4" class="img-student" :style="{ backgroundImage: `url('${studentImg}')` }" />
            <v-col cols="8" class="py-1">
                <div class="student-name text-truncate">
                    {{ student.name }}
                </div>
                <div class="student-sport text-truncate">
                    {{ student.sportSelected }}
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>

import {db} from '@/utils/Firebase'

export default {
    props: {
        studentId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            student: null,
        }
    },
    mounted() {
        var vm = this

        db.collection('users').doc(vm.studentId).get().then(student => {
            vm.student = student.data()
        })
    },
    computed: {
        studentImg(vm = this) {
            if(!vm.student.avatar) return require('@/assets/img/logo.png')
            return vm.student.avatar
        },
    },
}

</script>

<style scoped>

    .student-name {
        font-size: 13px;
        color: #707070;
    }

    .student-sport {
        font-size: 11px;
        color: #707070;
    }

    .img-student {
		background-position: 50% 50%;
		background-size: cover;
        height: 35px;
        background-color: rgba(0,0,0,0.05);
        border-radius: 3px;
	}

</style>